<!-- thank-you section start -->
<section class="section-b-space light-layout">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="success-text">
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                    <h2>Thank You</h2>
                    <p>Your Reservation Has Been Confirmed</p>
                </div>
            </div>
        </div>
    </div>
</section>